import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
export class SelectOptionStylingModel extends CoreStylingModel {
/**
 * Styles for option icon
 */
icon?: IconStylingModel;
/**
 * Styles for option label
 */
label?: StylingModel;
/**
 * Styles for option item
 */
item?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectOptionStylingModel_tsickle_Closure_declarations() {
/**
 * Styles for option icon
 * @type {?}
 */
SelectOptionStylingModel.prototype.icon;
/**
 * Styles for option label
 * @type {?}
 */
SelectOptionStylingModel.prototype.label;
/**
 * Styles for option item
 * @type {?}
 */
SelectOptionStylingModel.prototype.item;
}

